import {actionTypes} from "./actionTypes";

export const toggleLoseMessageCreateModal=()=>{
    return {
        type:actionTypes.TOGGLE_CREATE_LOSE_MESSAGE_MODAL,
    }
}